// NonConformityReport-specific validation - Uses generic validation utility
import { createValidation } from '../../utils/validation';

/**
 * NonConformityReport-specific validation factory
 * This is a thin wrapper around the generic validation utility
 * for backwards compatibility with existing NCR module code
 */
export const createNonConformityReportValidationSchema = (fields) => {
  const validation = createValidation(fields);
  
  // Return both generic and specific method names for flexibility
  return {
    schema: validation.schema,
    validateData: validation.validateData, // Generic name for configInit
    validateNonConformityReportData: validation.validateData, // Specific name for backwards compatibility
    validateField: validation.validateField
  };
};

// Default export for backwards compatibility
export default createNonConformityReportValidationSchema;
